import { useEffect } from "react"

import { Popover } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../../../../Icon"

import styles from "./questionField.module.less"

// The "Example" chip shown beside an evidence slot label; on hover it pops a
// brand-styled illustration of a strong sample upload.
const ExampleTag = ({ src, label }) => {
  const { t } = useTranslation()

  // Preload the illustration so the popover opens at the image's real size on the first
  // hover. Without this the popover sizes on empty content, then the image loads and
  // resizes it, which antd corrects by repositioning — the "jump".
  useEffect(() => {
    const img = new Image()
    img.src = src
  }, [src])

  return (
    <Popover
      placement="rightTop"
      arrow={false}
      trigger="hover"
      mouseEnterDelay={0.12}
      mouseLeaveDelay={0.12}
      // Disable antd's zoom motion: for a tall image it scales/repositions after
      // opening, which reads as a "jump up". We open at the final spot and just fade the
      // image in (see .exampleImg). rightTop anchors it predictably.
      transitionName=""
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      overlayClassName={styles.examplePop}
      content={
        <img
          src={src}
          alt={t("_label_ example", { label: t(label) })}
          className={styles.exampleImg}
          draggable={false}
        />
      }
    >
      <span className={styles.exampleTag}>
        <Icon type="circle_info_simple" />
        {t("Example")}
      </span>
    </Popover>
  )
}

export default ExampleTag
